<div class="data-preview-outer-wrapper">
<mat-tab-group>
    <mat-tab label="Sensor">
        <app-taskcost-sensor-preview
        [showCloseButton]="data?.isDialogBox??false"
        [showBackToNewTask]="showBackToNewTask"
        (closeRequested)="closeDialog()"></app-taskcost-sensor-preview>
    </mat-tab>
    <mat-tab label="Feeds" *ngIf="!data?.isDialogBox">
        <app-feeds-data-preview
        [showBackToNewTask]="showBackToNewTask"></app-feeds-data-preview>
    </mat-tab>
</mat-tab-group>
</div>